import React, { SyntheticEvent, useRef, useState,useEffect } from 'react';
import { Icon, ICONS, Loader, Tooltip, useTheme } from '@ohif/ui';
import { useSelector,useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import { PreviousAppointmentsData } from '@custom/rtk-apis/patients/patientAppointment';
import { formatDate } from '@custom/Utils/utils';
import moment from 'moment';

const PreviousAppointment = ({activeTabIndex,uhid}) => {
const { isDarkMode } = useTheme();
const{msg,result,loading,status}=useSelector((state: RootState) => state?.PreviousAppointmentresponce);
//const prevAppointmentdata = useSelector((state: RootState) => state?.PreviousAppointmentresponce?.result);
const dispatch=useDispatch<AppDispatch>()

  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  useEffect(()=>{
    if(activeTabIndex===1){
      const currentTime =moment().format('YYYY-MM-DDTHH:mm:ss');// new Date().toISOString();
      const limit = 10;
      const pageNumber = 1;
      dispatch(PreviousAppointmentsData({ uhid, currentTime, limit, pageNumber }));
    }
  },[activeTabIndex])

  const formatTime = (timeString: string) => {
    return timeString.split('T')[1];
  };

  return (
    <div className="space-y-2 mb-4 h-full">
      {result?.list && result.list.length > 0 ? (
        result.list.map((item, index) => (
          <div key={index} className="rounded-lg">
            <button
              onClick={() => toggleAccordion(index)}
              className="w-full accordion text-left px-4 py-2 bg-gray-100 rounded-t-lg hover:bg-gray-200"
              style={{ backgroundColor: isDarkMode ? '#090c29' : '#f7f7f7' }}
            >
              <span className='accordion-date'>{formatDate(item?.time,true)}</span>
              <span><img src={ICONS.downarrow} alt="down arrow" /></span>
            </button>
            {openIndex === index && (
              <div className="p-4 bg-white border-t">
                <p className='accordion-heading mb-4'>Patient Details</p>
                <div className='formRow formRow__4'>
                  <div className='formCol'>
                    <div className="form-group">
                      <label>Appointment Date</label>
                      <input
                        type="text"
                        className='disabled-field form__date form__date--sm'
                        disabled={true}
                        value={item?.date || ''}
                      />
                    </div>
                  </div>
                  <div className='formCol'>
                    <div className="form-group">
                      <label>Appointment Time</label>
                      <input
                        type="text"
                        className='disabled-field form__date form__date--sm'
                        disabled={true}
                        value={formatTime(item?.time) || ''}
                      />
                    </div>
                  </div>
                  <div className='formCol'>
                    <div className="form-group">
                      <label>Modality Type</label>
                      <input
                        type="text"
                        className='disabled-field form__date form__date--sm'
                        disabled={true}
                        value={item?.modality || ''}
                      />
                    </div>
                  </div>
                  <div className='formCol'>
                    <div className="form-group">
                      <label>Study Region</label>
                      <input
                        type="text"
                        className='disabled-field form__date form__date--sm'
                        disabled={true}
                        value={item?.studyRegion || ''}
                      />
                    </div>
                  </div>
                </div>
                <div className='formRow formRow__4'>
                  <div className='formCol'>
                    <div className="form-group">
                      <label>Priority</label>
                      <input
                        type="text"
                        className='disabled-field form__date form__date--sm'
                        disabled={true}
                        value={item?.priority || ''}
                      />
                    </div>
                  </div>
                  <div className='formCol'>
                    <div className="form-group">
                      <label>Consulting Doctor Name</label>
                      <input
                        type="text"
                        className='disabled-field form__date form__date--sm'
                        disabled={true}
                        value={item?.doctorName || ''}
                      />
                    </div>
                  </div>
                  <div className='formCol'>
                    <div className="form-group">
                      <label>Referring Doctor Name</label>
                      <input
                        type="text"
                        className='disabled-field form__date form__date--sm'
                        disabled={true}
                        value={item?.referDoctor || ''}
                      />
                    </div>
                  </div>
                  <div className='formCol'>
                    <div className="form-group">
                      <label>Referring Doctor Contact Number</label>
                      <input
                        type="text"
                        className='disabled-field form__date form__date--sm'
                        disabled={true}
                        value={item?.referDoctorContact || ''}
                      />
                    </div>
                  </div>
                </div>
                <div className='formRow formRow__4'>
                  <div className='formCol'>
                    <div className="form-group">
                      <label>Referring Doctor Speciality</label>
                      <input
                        type="text"
                        className='disabled-field form__date form__date--sm'
                        disabled={true}
                        value={item?.referDoctorSpec || ''}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))
      ) : (
        <div className="flex items-center justify-center h-full" style={{ height: '200px' }}>
          <p className="text-center text-gray-500">No data found</p>
        </div>
      )}
      {loading && <Loader isLoaderOpen={loading} />}
    </div>
  );
};

export default PreviousAppointment
